import React from 'react';
import PropTypes from 'prop-types';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { withRouter } from 'react-router';

import Footer from './components/Footer/Footer';
import LoadingModal from './containers/LoadingModal/LoadingModal';
import SnackBar from './containers/SnackBar/SnackBar';
import TopBar from './containers/TopBar/TopBar';

import Case from '@routes/Case/Case';
import Cases from '@routes/Cases/Cases';
import Landing from '@routes/Landing/Landing';
import PrivacyPolicy from '@routes/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from '@routes/TermsOfUse/TermsOfUse';
import Contact from '@routes/Contact/Contact';

import './App.scss';

class App extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="app">
        <TopBar />
        <Switch>
          <Route
            exact
            path="/"
            component={Landing}
          />
          <Route
            exact
            path="/cases"
            component={Cases}
          />
          <Route
            path="/cases/:id"
            component={Case}
          />
          <Route
            path="/contact"
            component={Contact}
          />
          <Route
            exact
            path="/privacy-policy"
            component={PrivacyPolicy}
          />
          <Route
            exact
            path="/terms-of-use"
            component={TermsOfUse}
          />
          <Redirect to="/" />
        </Switch>
        <div className="app__placeholder" />
        <Footer />
        <LoadingModal />
        <SnackBar />
      </div>
    );
  }
}

App.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/routes/App.js